module.exports = __webpack_public_path__ + "departed-n-f-days-ago.png?d38b9e8d52994eb799620db813da5b67";